import { MonthlyRunMode, MonthlyRunModeOption } from '../../store/types';

export const MONTHLY_RUN_MODE_OPTIONS: MonthlyRunModeOption[] = [
  {
    value: MonthlyRunMode.ClosestWeekendOnOrAfter,
    label: 'Run on closest weekend on or after the day',
    tooltip: 'If the chosen day is a weekend it runs that day, otherwise it runs on the next Saturday. This may fall in the following month or year.',
  },
  {
    value: MonthlyRunMode.ClosestWeekendOnOrBefore,
    label: 'Run on closest weekend on or before the day',
    tooltip:
      'If the chosen day is a weekend it runs that day, otherwise it runs on the Sunday immediately before. This may fall in the previous month or year.',
  },
  {
    value: MonthlyRunMode.ExactDay,
    label: 'Run on the day',
    tooltip: 'Runs on the chosen day. If the chosen day does not exist in a month, the last day of that month is used instead.',
  },
];
